import { Div, Input, router } from '@codesuma/baseline'
import style from './index.module.css'

// Step 1 of the New List wizard: the name. Emits 'text' as it's typed, and
// 'enter' on the keyboard's return key, which the page treats as Next.
export const NameStep = (value: string) => {
    const base = Div()
    base.addClass(style.base)

    const heading = Div('Name your list')
    heading.addClass(style.heading)

    const input = Input('e.g. Groceries')
    input.addClass(style.input)
    // The return key reads "Next" — on a phone the keyboard can cover the
    // buttons at the bottom, so the way on has to be on the keyboard too.
    input.attr('enterkeyhint', 'next')
    input.setValue(value)
    input.on('input', ({ value: next }: { value: string }) => base.emit('text', next))
    input.on('enter', () => base.emit('enter'))
    input.on('escape', () => router.back())

    // The moment someone wants a template: offer the curated catalog right
    // where they'd otherwise start from scratch.
    const discoverLink = Div('Or start from a ready-made list')
    discoverLink.addClass(style.discoverLink)
    discoverLink.el.onclick = () => router.goto('/discover')

    base.append(heading, input, discoverLink)

    return Object.assign(base, { focus: () => input.focus() })
}
